import { PrismicRichText } from "@prismicio/react";
import { Link } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import React from 'react';
import { components } from "../../utils/rt-mods";
import { colorCheck } from "../../utils/accessibility-helpers";

export const TextBlock = (props) => {

    const sc = props.slice.primary;

    const button = props.slice.items;

    let space = sc.spacing;

    if (space === "Both large") {
        space = "gutter";
    } else if (space === "Both small") {
        space = "gutter sm";
    } else if (space === "Top large") {
        space = "gutter bot";
    } else if (space === "Top small") {
        space = "gutter bot sm";
    } else if (space === "Bottom large") {
        space = "gutter top";
    } else {
        space = "gutter top sm";
    }

    let width = sc.width === "Full" ? "auto" : "3/4";

    let justify = sc.justify === "center" ? "center m-auto" : "left"

    let bg = sc.background === "gradient" ? "gradient-to-b from-grey-light to-white" : sc.background === "grey" ? "grey-light" : sc.background;


    let boxbg = sc.box_background === "gradient" ? "gradient-to-b from-grey-light to-white" : sc.box_background === "grey" ? "grey-light" : sc.background;

    let isThereBox = sc.box ? " p-8 md:p-16 bg-" + boxbg : '';

    // Add bullet class based on alignment for checkmark bullets
    let bulletClass = sc.justify === "center" ? "textblock-bullets-center" : "textblock-bullets-left";

    return (
        <section className={"textblock " + bulletClass + " bg-" + (bg) + " " + (sc.theme) + " " + (space)}>
            <div className="wrapper">
                <div className={"w-auto rounded-lg md:rounded-2xl md:w-" + (width) + " " + "text-" + (justify) + " " + (sc.border ? 'border border-' + (sc.theme) : '') + (isThereBox)}>
                    {sc.icon.url ? <div className="icon mb-4"><img className={"w-16 m-auto " + (sc.theme)} src={sc.icon.url} alt="" /></div> : (sc.graphic.url ? <GatsbyImage className="w-3/5 md:w-1/4 mb-4 rounded-lg" image={getImage(sc.graphic)} alt={sc.graphic.alt} /> : '') }
                    {sc.label ? <div className={"label bg-opacity-10 font-bold uppercase tracking-widest text-xs mb-1 md:mb-2 text-" + colorCheck(sc.theme)}>{sc.label}</div> : "" }
                <PrismicRichText field={sc.block_title.richText} />
                <PrismicRichText field={sc.block_content.richText} components={components} />
                    
                        {button.map((btn, index) => {
                            if (btn.button_link == null) {
                                return ""
                            }
                            return <Link key={index} to={btn.button_link.url} target={(btn.button_link.target === "_blank" ? btn.button_link.target : '_self')} className={"btn bg-" + (btn.button_color)}>{btn.label}</Link>
                        })}
                </div>
                
            </div>
        </section>
    );
}

